<template>
    <b-modal :active.sync="showModal" scroll="keep">
        <div class="modal-card" style="width: auto">
            <div class="modal-card-body has-text-centered">

                <b-field label="Display en home">
                    <b-switch
                    v-model="item.display">
                    </b-switch>
                </b-field>

                <b-field label="Imagen">
                    <b-upload 
                        v-model="dropImage"
                        drag-drop
                        @input="encodeImage"
                        >
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                               <p>Arrastra tus fotos hasta aqui, o haz click.</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>

                <div class="columns is-multiline">
                    <div v-if="item.image" class="column is-full has-text-centered">
                        <img style="max-width=260px" :src="item.image" alt="">
                    </div>

                    <div class="column is-full has-text-centered">
                        <b-button
                        type="is-primary"
                        rounded
                        @click="saveSub">
                        <b-icon icon="save" size="is-small"></b-icon>
                        Guardar detalles
                        </b-button>
                    </div>

                </div>

            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    props:{
        showModal:{
            type:Boolean,
            default:false
        },
        item:{
            type:Object,
            default: new Object({})
        }
    },
    data(){
        return{
            dropImage:null,
        }
    },
    methods:{
        encodeImage(){
            let reader = new FileReader();
            reader.readAsDataURL(this.dropImage);
            reader.onloadend = (event) => {
                this.item.image = reader.result
            }
        },
        saveSub(){
            this.$emit("update", this.item)
        }
    }
}
</script>